"use client";
import React from "react";
import { MdArrowForwardIos, MdOutlineArrowBackIosNew } from "react-icons/md";
import "./PaginationBtn.css";
import { useState } from "react";
import { FiCornerDownLeft } from "react-icons/fi"; // ⏎ icon

export default function PaginationButton({
  page = 1,
  setPage,
  totalPages = 1,
}) {
  const [inputPage, setInputPage] = useState("");

  const handleGoToPage = () => {
    const pageNumber = parseInt(inputPage, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
    setInputPage("");
  };
  return (
    <div
      className="d-flex justify-content-center align-items-center paginationContainer"
      style={{ gap: "10px" }}
    >
      {" "}
      <div className="d-flex align-items-center ">
        <div className="input-container">
          <input
            type="number"
            min="1"
            max={totalPages}
            value={inputPage}
            onChange={(e) => setInputPage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                const pageNumber = parseInt(inputPage, 10);
                if (
                  !isNaN(pageNumber) &&
                  pageNumber >= 1 &&
                  pageNumber <= totalPages
                ) {
                  setPage(pageNumber);
                  setInputPage("");
                }
              }
            }}
            placeholder="Page #"
            className="page-input"
          />
          <span className="input-icon">⏎</span>
        </div>
      </div>
      <div className="paginationButton">
        <button
          disabled={page === 1}
          className="d-flex align-items-center"
          onClick={() => setPage(page - 1)}
          title="Previous Page"
        >
          <MdOutlineArrowBackIosNew />
        </button>
        <button title="Current Page">{page}</button>
        <div title="Total Pages">
          {totalPages
            ? `of ${totalPages} Page${totalPages > 1 ? "s" : ""}`
            : "No Pages"}
        </div>

        <button
          disabled={page === totalPages || totalPages === 0}
          onClick={() => setPage(page + 1)}
          className="d-flex align-items-center"
          title="Next Page"
        >
          <MdArrowForwardIos />
        </button>
      </div>
    </div>
  );
}
